// Tiny localStorage-backed watched-set helper. Single-user, single-device persistence.
const KEY = "crt_watched_videos";

function readSet() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  } catch (e) {
    return new Set();
  }
}

function writeSet(set) {
  try {
    localStorage.setItem(KEY, JSON.stringify(Array.from(set)));
  } catch (e) {
    /* ignore quota errors */
  }
}

export function getWatched() {
  return readSet();
}

export function markWatched(videoId) {
  if (!videoId) return;
  const s = readSet();
  if (s.has(videoId)) return;
  s.add(videoId);
  writeSet(s);
}

export function clearWatched() {
  try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
}
